var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurvaluesvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 6.33325L22.7436 27.9999L13 18.3703",
    stroke: "#000064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5221 20.5925C44.6189 21.3913 44.6672 22.1953 44.6666 22.9999C44.6666 27.2852 43.3959 31.4742 41.0151 35.0373C38.6343 38.6003 35.2505 41.3774 31.2914 43.0173C27.3323 44.6572 22.9759 45.0863 18.773 44.2503C14.57 43.4142 10.7094 41.3507 7.67928 38.3206C4.64914 35.2904 2.58559 31.4298 1.74958 27.2269C0.913568 23.0239 1.34264 18.6675 2.98254 14.7084C4.62244 10.7494 7.39951 7.36551 10.9626 4.98474C14.5256 2.60398 18.7147 1.33325 22.9999 1.33325C26.3548 1.36456 29.6546 2.18952 32.6295 3.74066",
    stroke: "#000064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurvaluesvg1);
export default __webpack_public_path__ + "static/media/ourvaluesvg1.be5fb4098d64a4473fb6025ef59c4033.svg";
export { ForwardRef as ReactComponent };